import _isEmpty from 'lodash-es/isEmpty'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'

import dynamic from 'next/dynamic'
import { capitalizeEveryWord } from 'helpers/string'
import {
  adsAxiosInstance,
  unInterceptedAdsAxiosInstance,
} from 'api/adsAxiosClient'

const JobPage = dynamic(() =>
  import('containers/JobPage').then((res) => res.JobPage)
)

export default withAuth(JobPage, {
  LoggedOutComponent: JobPage,
})

const renderPageTitle = (job) => {
  let title = job.title
  const location = job.formatted_location_verbose

  if (job.title === job.title.toLowerCase()) {
    title = capitalizeEveryWord(job.title)
  }

  if (location) {
    return `${title} jobs in ${location} at ${job.company_name}`
  }
  return `${title} jobs at ${job.company_name}`
}

const fetchJobFromJobRef = async (context, user) => {
  try {
    const adminAuthToken = user?.ad_network_admin_authorization_token

    const axiosInstance = adminAuthToken
      ? unInterceptedAdsAxiosInstance
      : adsAxiosInstance

    const response = (
      await axiosInstance.post(
        `/jobs`,
        {
          job: {
            user_rid: user?.rid,
            user_lat_long: [user?.lat, user?.long],
            job_reference_clean: context.params.jobRefClean,
            sort: 'title',
            direction: 'desc',
            jobs_per_page: 1,
            page: 1,
            show_aggregations: false,
          },
        },
        {
          ...(!_isEmpty(adminAuthToken) && {
            headers: {
              Authorization: adminAuthToken,
            },
          }),
        }
      )
    ).data

    if (response.results.length) {
      const job = response.results[0]
      return {
        job: job,
        title: renderPageTitle(job),
        description:
          job.body?.replaceAll('<br><br>', '<br>') || job?.company_description,
        image: job?.company_logo_url || job?.companyLogoUrl,
      }
    }
    return {
      redirect: {
        destination: '/search/jobs',
        permanent: false,
      },
    }
  } catch (e) {
    console.error('Error on fetching job from jobId', e)
    return {
      redirect: {
        destination: '/search/jobs',
        permanent: false,
      },
    }
  }
}

export const getServerSideProps = withAuthServerSideProps(fetchJobFromJobRef)

// const ldJsonData = useMemo(() => {
//   return {
//     '@context': 'https://schema.org',
//     '@type': 'JobPosting',
//     baseSalary: job.enriched_salary_medium_usd,
//     datePosted: moment(job.posted_at).format('MMM DD, YYYY'),
//     description: job.body?.replaceAll('<br><br>', '<br>'),
//     hiringOrganization: {
//       name: job.company_name,
//       logo: job.company_logo_url,
//     },
//     employmentType: job.employment_type
//       ? capitalizeReplaceUnderscore(job.employment_type)
//       : null,
//     industry: job.company_industry,
//     jobLocation: {
//       '@type': 'Place',
//       address: {
//         '@type': 'PostalAddress',
//         addressCountry: job.google_ld_country,
//         addressLocality: job.google_ld_city,
//         addressRegion: job.google_ld_state,
//         postalCode: job.google_ld_postal_code,
//         streetAddress: job.google_ld_street_address,
//       },
//     },
//     occupationalCategory: job.company_industry,
//     salaryCurrency: 'USD',
//     validThrough: job.posting_deadline,
//     directApply: true,
//     title: job.title,
//   }
// }, [job])
